import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import OnboardingRoutes from "./OnboardingRoutes";
import OnboardingSheet from "./OnboardingSheet";

export default function OnboardingSheetGate() {
  const location = useLocation();
  const onOnboarding = location.pathname.startsWith("/onboarding");
  const [holdSheet, setHoldSheet] = useState(false);

  const showSheet = onOnboarding || holdSheet;
  if (!showSheet) return null;

  return (
    <OnboardingSheet
      onRequestHold={() => setHoldSheet(true)}
      onReleaseHold={() => setHoldSheet(false)}
    >
      {onOnboarding ? <OnboardingRoutes /> : null}
    </OnboardingSheet>
  );
}
